(function () {
  var C = window.PLUSH_CUSTOMIZER_CONFIG;
  if (!C || !C.customizer) return;

  var root = document.getElementById('plush-clone-customizer');
  if (!root) return;

  var omsPlushDetails = C.omsPlushDetails || [];
  var omsHeader = omsPlushDetails[0]
    ? { 'api-token': omsPlushDetails[0].api_token }
    : {};

  var plushMaxImageBytes = 15 * 1000 * 1000;
  var maxImages = 6;
  var requireImages = parseInt(root.getAttribute('data-require-images') || '3', 10);
  var currentStep = 1;
  var totalSteps = 5;
  var selectedPetTypeName = '';
  var breedList = [];
  var photoStore = [null, null, null, null, null, null];
  var creationPriceCents = 0;
  var creationWeeks = 8;
  var framePriceCents = 0;
  var extrasTotals = {};

  function resolveBaseCents() {
    var candidates = [
      C.plushProduct && C.plushProduct.price,
      document.getElementById('creationTotalAmount')?.getAttribute('data-base-cents'),
      root.getAttribute('data-base-cents'),
    ];
    for (var i = 0; i < candidates.length; i++) {
      if (candidates[i] == null || candidates[i] === '') continue;
      var n = parseInt(String(candidates[i]), 10);
      if (Number.isFinite(n) && n >= 0) return n;
    }
    return 0;
  }

  var BASE_CENTS = resolveBaseCents();

  (function initBundleKey() {
    var el = document.getElementById('originalUniqueKey');
    if (el) el.value = String(Date.now());
  })();

  function $(sel, ctx) {
    return (ctx || root).querySelector(sel);
  }
  function $$(sel, ctx) {
    return Array.prototype.slice.call((ctx || root).querySelectorAll(sel));
  }

  function possessive(name) {
    var last = name.slice(-1).toLowerCase();
    return last === 's' ? name + '\u2019' : name + '\u2019s';
  }

  var DEFAULT_FORM_TITLE = 'Your Pet. Immortalized In Plush.';

  function formatMoneyCents(cents) {
    var n = Number(cents);
    if (!Number.isFinite(n)) return '$0.00';
    try {
      if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
        var fmt =
          window.money_format ||
          (window.theme && window.theme.settings && window.theme.settings.moneyFormat);
        if (fmt) return Shopify.formatMoney(n, fmt);
      }
    } catch (e) {}
    return '$' + (n / 100).toFixed(2);
  }

  function parsePriceToCents(str) {
    if (str == null || str === '') return 0;
    if (typeof str === 'number') return Math.round(str);
    var s = String(str).replace(/[^0-9.]/g, '');
    var f = parseFloat(s);
    return Number.isFinite(f) ? Math.round(f * 100) : 0;
  }

  function getPetName() {
    var el = document.getElementById('petname');
    return el ? el.value.trim() : '';
  }

  function renderProgress() {
    if (window.CC_WIREFRAME_PROGRESS) {
      window.CC_WIREFRAME_PROGRESS.renderSteps(currentStep);
    }
  }

  function getScrollAnchorOffset() {
    if (window.CC_WIREFRAME_PROGRESS) {
      return window.CC_WIREFRAME_PROGRESS.getScrollAnchorOffset(root);
    }
    return 120;
  }

  function scrollToStep(n) {
    var target = root.querySelector('.step-panel[data-panel="' + n + '"]');
    if (target) {
      var top = target.getBoundingClientRect().top + window.pageYOffset - getScrollAnchorOffset();
      window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
    }
  }

  function unlockStep(n) {
    $$('.step-panel').forEach(function (p) {
      p.classList.toggle('is-locked', parseInt(p.getAttribute('data-panel'), 10) > n);
    });
    currentStep = n;
    renderProgress();
    scrollToStep(n);
    if (n === 4) updateShipConfirm();
    if (n === 5) updateExtrasSubhead();
  }

  function goBack() {
    if (currentStep > 1) scrollToStep(currentStep - 1);
  }

  function updateDynamicTitle() {
    var name = getPetName();
    var title = $('#formDynamicTitle');
    if (title) {
      title.textContent = name
        ? "Let\u2019s Build " + possessive(name) + ' Clone'
        : DEFAULT_FORM_TITLE;
    }
    updateSlotLabels();
    updateShipConfirm();
    updateExtrasSubhead();
  }

  function updateSlotLabels() {
    var name = getPetName();
    var prefix = name ? possessive(name) + ' ' : '';
    for (var i = 0; i < 3; i++) {
      var lbl = document.getElementById('slotLabel' + i);
      if (lbl) lbl.textContent = prefix + 'Image ' + (i + 1) + ' *';
    }
  }

  function updateExtrasSubhead() {
    var name = getPetName();
    var sub = document.getElementById('extrasSubhead');
    if (sub) {
      sub.textContent = name
        ? 'A few finishing touches for ' + possessive(name) + ' clone \u2014 all optional, all worth it.'
        : 'A few finishing touches for your clone \u2014 all optional, all worth it.';
    }
  }

  function formatShipDate(weeksFromNow) {
    var d = new Date();
    d.setDate(d.getDate() + weeksFromNow * 7);
    var months = [
      'January', 'February', 'March', 'April', 'May', 'June',
      'July', 'August', 'September', 'October', 'November', 'December',
    ];
    return months[d.getMonth()] + ' ' + d.getDate() + ', ' + d.getFullYear();
  }

  function updateShipConfirm() {
    var name = getPetName();
    var noun = name ? possessive(name) + ' plush clone' : 'Your plush clone';
    $$('#creationWindowList .creation-card').forEach(function (card) {
      var weeks = parseInt(card.getAttribute('data-weeks'), 10) || 0;
      var textEl = card.querySelector('.creation-card__confirm-text');
      if (textEl) {
        textEl.innerHTML =
          noun +
          ' will be finished &amp; ready to ship on <strong class="ship-date">' +
          formatShipDate(weeks) +
          '</strong>.';
      }
    });
  }

  function updateTotal() {
    var addons = Object.values(extrasTotals).reduce(function (a, b) {
      return a + b;
    }, 0);
    var count = Object.keys(extrasTotals).length;
    var grand = BASE_CENTS + addons + creationPriceCents + framePriceCents;

    var ids = ['addonTotalAmount', 'creationTotalAmount'];
    ids.forEach(function (id) {
      var el = document.getElementById(id);
      if (el) el.textContent = formatMoneyCents(grand);
    });

    var addonsLabel = document.getElementById('addonsLabel');
    if (addonsLabel) {
      addonsLabel.textContent =
        count === 0
          ? 'No add-ons selected'
          : '+$' + (addons / 100).toFixed(2) + ' in add-ons (' + count + ' selected)';
    }

    var creationLbl = document.getElementById('creationAddonsLabel');
    if (creationLbl) {
      var parts = [];
      if (count > 0) parts.push('+$' + (addons / 100).toFixed(2) + ' add-ons');
      if (creationPriceCents > 0) {
        var sel = $('#rushSelect');
        var label = sel && sel.options[sel.selectedIndex] ? sel.options[sel.selectedIndex].text : 'Rush';
        parts.push('+$' + (creationPriceCents / 100).toFixed(2) + ' ' + label);
      }
      creationLbl.textContent = parts.length ? parts.join(' \u00b7 ') : 'No add-ons selected';
    }

    var step4Total = document.getElementById('step4Total');
    if (step4Total) step4Total.textContent = '\u00b7 ' + formatMoneyCents(grand);
    var ctaTotal = document.getElementById('ctaTotal');
    if (ctaTotal) ctaTotal.textContent = '\u00b7 ' + formatMoneyCents(grand);

    var installmentCents = Math.round(grand / 4);
    $$('[data-pcc-installment], [data-pcc-sticky-installment]', root).forEach(function (el) {
      el.textContent = formatMoneyCents(installmentCents);
    });
    $$('[data-pcc-base-price], [data-pcc-sticky-total]', root).forEach(function (el) {
      el.textContent = formatMoneyCents(grand);
    });
  }

  function openCartDrawer() {
    if (typeof refreshCartJS === 'function') {
      refreshCartJS();
      return;
    }
    var cartSlide = document.querySelector('cart-slide');
    if (!cartSlide) return;
    if (cartSlide.refreshCart) cartSlide.refreshCart();
    if (cartSlide.toggleCart && !cartSlide.classList.contains('active')) {
      cartSlide.toggleCart();
    }
  }

  function getSelectedSpecies() {
    var sel = $('#speciesGrid .species-item.is-selected');
    return sel ? sel.getAttribute('data-value') : '';
  }

  function setSpecies(value, preselectBreed) {
    selectedPetTypeName = value;
    var petType = document.getElementById('pet-type');
    if (petType) petType.value = value;
    $$('#speciesGrid .species-item').forEach(function (el) {
      el.classList.toggle('is-selected', el.getAttribute('data-value') === value);
    });
    fetchBreeds(value, preselectBreed);
    renderPositionOptions(value);
    renderEarOptions(value);
  }

  $$('#speciesGrid .species-item').forEach(function (el) {
    el.addEventListener('click', function () {
      setSpecies(el.getAttribute('data-value'));
    });
  });

  function fetchBreeds(species, preselectBreed) {
    if (!omsPlushDetails[0] || !species) return;
    fetch(omsPlushDetails[0].url + 'breeds?specie=' + encodeURIComponent(species), {
      method: 'GET',
      headers: omsHeader,
    })
      .then(function (r) {
        if (!r.ok) throw new Error('breeds fetch failed');
        return r.json();
      })
      .then(function (data) {
        breedList = (data && data.breeds) || [];
        var select = document.getElementById('breedSelect');
        if (!select) return;
        select.innerHTML = '<option value="" disabled selected>Select breed</option>';
        breedList.forEach(function (b) {
          var label = breedLabel(b);
          if (!label) return;
          var opt = document.createElement('option');
          opt.value = label;
          opt.textContent = label;
          select.appendChild(opt);
        });
        // Reflect a stored/preselected breed once its options exist; otherwise reset.
        if (preselectBreed && String(preselectBreed).trim()) {
          selectBreed(String(preselectBreed).trim());
        } else {
          if (breedInput) breedInput.value = '';
          setBreedSelectValue('');
        }
        closeBreedSuggestions();
        updateBreathingBoxByBreed();
      })
      .catch(function (e) {
        console.error('Breeds:', e);
        breedList = [];
      });
  }

  var breedInput = document.getElementById('petBreed');
  var breedSuggestions = document.getElementById('breedSuggestions');
  var activeBreedIndex = -1;

  function breedLabel(b) {
    return (b && (b.description || b.name || b.text)) || '';
  }

  function findBreedSelectValue(label) {
    var select = document.getElementById('breedSelect');
    if (!select || !label) return '';
    var q = String(label).trim().toLowerCase();
    if (!q) return '';
    for (var i = 0; i < select.options.length; i++) {
      var opt = select.options[i];
      if (!opt.value || opt.disabled) continue;
      if (opt.value.toLowerCase() === q) return opt.value;
    }
    return '';
  }

  function resolveMixedBreedValue() {
    return (
      findBreedSelectValue('Other/Mixed') ||
      findBreedSelectValue('Mixed Breed') ||
      (function () {
        var select = document.getElementById('breedSelect');
        if (!select) return 'Other/Mixed';
        for (var i = 0; i < select.options.length; i++) {
          var v = select.options[i].value;
          if (v && /mixed/i.test(v)) return v;
        }
        return 'Other/Mixed';
      })()
    );
  }

  function getSelectedBreedValue() {
    var select = document.getElementById('breedSelect');
    return select && select.value ? String(select.value).trim() : '';
  }

  function getBreedByLabel(label) {
    if (!label) return null;
    var q = String(label).trim().toLowerCase();
    for (var i = 0; i < breedList.length; i++) {
      if (breedLabel(breedList[i]).toLowerCase() === q) return breedList[i];
    }
    return null;
  }

  // Show the Breathing Box add-on only when the selected breed supports it
  // (breed.breathing_box === true). Otherwise hide it and clear any selection.
  function updateBreathingBoxByBreed() {
    var card = document.querySelector('.breathing_box_body');
    if (!card) return;
    var breed = getBreedByLabel(getSelectedBreedValue());
    var allow = !!(breed && breed.breathing_box);
    card.style.display = allow ? '' : 'none';
    if (!allow) {
      var cb = card.querySelector('.breathing_box_checkbox');
      if (cb && cb.checked) {
        cb.checked = false;
        cb.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
  }

  function setBreedSelectValue(value) {
    var select = document.getElementById('breedSelect');
    if (!select) return false;
    if (!value) {
      select.selectedIndex = 0;
      return false;
    }
    for (var i = 0; i < select.options.length; i++) {
      if (select.options[i].value === value) {
        select.selectedIndex = i;
        return true;
      }
    }
    select.selectedIndex = 0;
    return false;
  }

  function closeBreedSuggestions() {
    if (breedSuggestions) {
      breedSuggestions.classList.remove('is-open');
      breedSuggestions.innerHTML = '';
    }
    activeBreedIndex = -1;
  }

  function selectBreed(value) {
    if (!value) return;
    var label = String(value).trim();
    if (!label) return;

    var resolved = findBreedSelectValue(label);
    if (!resolved) {
      for (var i = 0; i < breedList.length; i++) {
        var desc = breedLabel(breedList[i]);
        if (desc.toLowerCase() === label.toLowerCase()) {
          resolved = desc;
          break;
        }
      }
    }
    if (!resolved) resolved = label;

    if (breedInput) breedInput.value = resolved;
    if (!setBreedSelectValue(resolved)) {
      var select = document.getElementById('breedSelect');
      if (select) {
        var opt = document.createElement('option');
        opt.value = resolved;
        opt.textContent = resolved;
        select.appendChild(opt);
        setBreedSelectValue(resolved);
      }
    }
    $('#fieldPetBreed')?.classList.remove('is-invalid');
    closeBreedSuggestions();
    updateBreathingBoxByBreed();
  }

  function bindBreedSuggestionItem(item) {
    function pick(e) {
      e.preventDefault();
      e.stopPropagation();
      selectBreed(item.getAttribute('data-value'));
    }
    item.addEventListener('mousedown', pick);
    item.addEventListener('pointerdown', pick);
  }

  function getBreedMatches(query) {
    if (!breedList.length) return [];
    var q = (query || '').trim().toLowerCase();
    if (!q) return breedList.slice(0, 8);
    return breedList
      .filter(function (b) {
        return breedLabel(b).toLowerCase().indexOf(q) !== -1;
      })
      .slice(0, 8);
  }

  function renderBreedSuggestions(query) {
    if (!breedSuggestions) return;
    var q = (query || '').trim().toLowerCase();
    var matches = getBreedMatches(query);
    if (!matches.length) {
      closeBreedSuggestions();
      return;
    }
    activeBreedIndex = -1;
    breedSuggestions.innerHTML = matches
      .map(function (b, i) {
        var desc = breedLabel(b);
        var highlighted = desc;
        if (q) {
          highlighted = desc.replace(
            new RegExp('(' + q.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + ')', 'gi'),
            '<strong>$1</strong>'
          );
        }
        return (
          '<div class="breed-suggestion-item" role="option" data-index="' +
          i +
          '" data-value="' +
          desc.replace(/"/g, '&quot;') +
          '">' +
          highlighted +
          '</div>'
        );
      })
      .join('');
    breedSuggestions.classList.add('is-open');
    $$('.breed-suggestion-item', breedSuggestions).forEach(bindBreedSuggestionItem);
  }

  if (breedInput) {
    breedInput.addEventListener('focus', function () {
      renderBreedSuggestions(this.value);
    });
    breedInput.addEventListener('input', function () {
      renderBreedSuggestions(this.value);
      var matched = findBreedSelectValue(this.value.trim());
      setBreedSelectValue(matched || '');
    });
    breedInput.addEventListener('blur', function () {
      var matched = findBreedSelectValue(this.value.trim());
      if (matched) selectBreed(matched);
    });
    breedInput.addEventListener('keydown', function (e) {
      var items = $$('.breed-suggestion-item', breedSuggestions);
      if (!items.length) return;
      if (e.key === 'ArrowDown') {
        e.preventDefault();
        activeBreedIndex = Math.min(activeBreedIndex + 1, items.length - 1);
      } else if (e.key === 'ArrowUp') {
        e.preventDefault();
        activeBreedIndex = Math.max(activeBreedIndex - 1, -1);
      } else if (e.key === 'Enter' && activeBreedIndex >= 0) {
        e.preventDefault();
        selectBreed(items[activeBreedIndex].getAttribute('data-value'));
        return;
      } else if (e.key === 'Escape') {
        closeBreedSuggestions();
        return;
      } else return;
      items.forEach(function (item, i) {
        item.classList.toggle('is-active', i === activeBreedIndex);
      });
    });
  }

  document.addEventListener('mousedown', function (e) {
    if (!breedSuggestions || !breedSuggestions.classList.contains('is-open')) return;
    if (e.target.closest && e.target.closest('#fieldPetBreed')) return;
    closeBreedSuggestions();
  });

  var mixedBtn = document.getElementById('mixedBreedBtn');
  if (mixedBtn) {
    mixedBtn.addEventListener('mousedown', function (e) {
      e.preventDefault();
      selectBreed(resolveMixedBreedValue());
    });
  }

  function validateStep1() {
    var name = getPetName();
    var age = document.getElementById('petAge')?.value || '';
    var typedBreed = breedInput ? breedInput.value.trim() : '';
    if (typedBreed && !getSelectedBreedValue()) {
      selectBreed(typedBreed);
    }
    var breed = getSelectedBreedValue() || findBreedSelectValue(typedBreed);
    var email = document.getElementById('email')?.value.trim() || '';
    var emailOk = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

    $('#fieldPetName')?.classList.toggle('is-invalid', !name);
    $('#fieldPetAge')?.classList.toggle('is-invalid', !age);
    $('#fieldPetBreed')?.classList.toggle('is-invalid', !breed);
    $('#fieldEmail')?.classList.toggle('is-invalid', !emailOk);

    if (name && age && breed && emailOk) {
      if (breedInput) breedInput.value = breed;
      sendKlaviyo(name, email, age, breed);
      updateSlotLabels();
      unlockStep(2);
    }
  }

  function sendKlaviyo(name, email, age, breed) {
    if (!omsPlushDetails[0]) return;
    try {
      fetch(omsPlushDetails[0].url + 'klaviyo_api/send_pet_detail_to_klaviyo', {
        method: 'POST',
        headers: Object.assign({ 'Content-Type': 'application/json' }, omsHeader),
        body: JSON.stringify({
          pet_name: name,
          email: email,
          pet_age: age,
          pet_breed: breed,
          pet_type: selectedPetTypeName,
        }),
      }).catch(function () {});
    } catch (e) {}
  }

  function rejectFileSize(file, inputEl) {
    if (!file) return true;
    var n = file.size;
    if (!Number.isFinite(n) || n <= 0 || n > plushMaxImageBytes) {
      alert('Maximum file size is 15 MB per image.');
      if (inputEl) inputEl.value = '';
      return true;
    }
    return false;
  }

  function isRemoteImageUrl(url) {
    return typeof url === 'string' && /^https?:\/\//i.test(url);
  }

  function getSlotPreviewEl(idx) {
    return document.getElementById('pcc-slot-preview-' + idx);
  }

  function setSlotPreview(idx, dataUrl) {
    var preview = getSlotPreviewEl(idx);
    if (!preview) return;
    if (dataUrl) {
      preview.style.backgroundImage = 'url(' + dataUrl + ')';
    } else {
      preview.style.backgroundImage = '';
      preview.style.background = '';
    }
  }

  function uploadToOms(file, onSuccess, onError) {
    if (!omsPlushDetails[0] || !omsPlushDetails[0].url) {
      onError(new Error('Upload service unavailable'));
      return;
    }
    var xhr = new XMLHttpRequest();
    xhr.open('POST', omsPlushDetails[0].url + 'image_uploader/print_image');
    xhr.setRequestHeader('api-token', omsPlushDetails[0].api_token);
    xhr.onload = function () {
      if (xhr.status === 200 || xhr.status === 201) {
        try {
          var data = JSON.parse(xhr.responseText);
          if (data && data.imageUrl) onSuccess(data.imageUrl);
          else onError(new Error('Invalid upload response'));
        } catch (e) {
          onError(e);
        }
      } else {
        onError(new Error('Upload failed (' + xhr.status + ')'));
      }
    };
    xhr.onerror = function () {
      onError(new Error('Network error'));
    };
    var fd = new FormData();
    fd.append('image', file);
    xhr.send(fd);
  }

  function markSlotFilled(slot, idx, dataUrl, ready) {
    setSlotPreview(idx, dataUrl);
    if (ready) {
      photoStore[idx] = dataUrl;
    }
    slot.classList.add('has-file');
    slot.classList.remove('is-invalid', 'is-uploading');
    $('#photosError')?.classList.remove('is-visible');
  }

  function clearSlot(idx) {
    photoStore[idx] = null;
    var slot = root.querySelector('.photo-slot[data-slot="' + idx + '"]');
    setSlotPreview(idx, null);
    if (slot) {
      slot.classList.remove('has-file', 'is-uploading', 'is-invalid');
      var input = slot.querySelector('.pcc-photo-input');
      if (input) input.value = '';
    }
  }

  function openPhotoPicker(slot) {
    if (!slot || slot.classList.contains('is-uploading')) return;
    var input = slot.querySelector('.pcc-photo-input');
    if (input) {
      input.value = '';
      input.click();
    }
  }

  function processSelectedFile(file, slot, idx, input) {
    if (rejectFileSize(file, input)) return;

    var reader = new FileReader();
    reader.onload = function (ev) {
      markSlotFilled(slot, idx, ev.target.result, false);
      slot.classList.add('is-uploading');
    };
    reader.onerror = function () {
      alert('Could not read this image. Please try another file.');
      input.value = '';
    };
    reader.readAsDataURL(file);

    var uploadFile = function (f) {
      uploadToOms(
        f,
        function (url) {
          markSlotFilled(slot, idx, url, true);
        },
        function () {
          clearSlot(idx);
          alert('Upload failed. Please try again.');
        }
      );
    };

    if (typeof heic2any !== 'undefined' && /\.(heic|heif)$/i.test(file.name)) {
      heic2any({ blob: file, toType: 'image/jpeg' })
        .then(function (blob) {
          var out = Array.isArray(blob) ? blob[0] : blob;
          uploadFile(
            new File([out], file.name.replace(/\.(heic|heif)$/i, '.jpg'), {
              type: 'image/jpeg',
            })
          );
        })
        .catch(function () {
          uploadFile(file);
        });
    } else {
      uploadFile(file);
    }
  }

  $$('.photo-slot').forEach(function (slot) {
    slot.addEventListener('click', function (e) {
      if (e.target.closest('.photo-slot__remove')) return;
      openPhotoPicker(slot);
    });
    slot.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        openPhotoPicker(slot);
      }
    });
  });

  $$('.pcc-photo-input').forEach(function (input) {
    input.addEventListener('change', function (e) {
      var idx = parseInt(input.getAttribute('data-slot'), 10);
      var file = e.target.files && e.target.files[0];
      if (!file) return;
      var slot = input.closest('.photo-slot');
      if (!slot) return;
      processSelectedFile(file, slot, idx, input);
    });
  });

  $$('.photo-slot__remove').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      clearSlot(parseInt(btn.getAttribute('data-remove'), 10));
    });
  });

  function validateStep2() {
    var allFilled = true;
    $$('.photo-slot[data-required="true"]').forEach(function (slot) {
      var idx = parseInt(slot.getAttribute('data-slot'), 10);
      var uploading = slot.classList.contains('is-uploading');
      var filled = !uploading && isRemoteImageUrl(photoStore[idx]);
      slot.classList.toggle('is-invalid', !filled);
      if (!filled) allFilled = false;
    });
    var errEl = document.getElementById('photosError');
    if (!allFilled) {
      errEl?.classList.add('is-visible');
      errEl?.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      return;
    }
    errEl?.classList.remove('is-visible');
    unlockStep(3);
  }

  function handleImages() {
    var existing = document.getElementById('image-links');
    if (existing) existing.remove();
    var div = document.createElement('div');
    div.id = 'image-links';
    var idx = 0;
    photoStore.forEach(function (url) {
      if (isRemoteImageUrl(url)) {
        idx++;
        var hidden = document.createElement('input');
        hidden.type = 'hidden';
        hidden.className = 'uploadedHiddenImages';
        hidden.name = 'properties[image_' + idx + ']';
        hidden.value = url;
        div.appendChild(hidden);
      }
    });
    var host = document.getElementById('pcc-image-links-host');
    if (host) host.appendChild(div);
  }

  var eyeState = { left: '', right: '', side: 'left', split: false };

  function initEyeDefault() {
    var first = $('#eyeColorGrid .color-item.is-selected');
    if (first) {
      var v = first.getAttribute('data-value');
      eyeState.left = v;
      eyeState.right = v;
      document.getElementById('left-eye-color').value = v;
      document.getElementById('right-eye-color').value = v;
    }
  }

  function renderEyeSelection() {
    var active = eyeState.split ? eyeState[eyeState.side] : eyeState.left;
    $$('#eyeColorGrid .color-item').forEach(function (el) {
      el.classList.toggle('is-selected', el.getAttribute('data-value') === active);
    });
    document.getElementById('left-eye-color').value = eyeState.left;
    document.getElementById('right-eye-color').value = eyeState.right;
  }

  $$('#eyeColorGrid .color-item').forEach(function (el) {
    el.addEventListener('click', function () {
      var val = el.getAttribute('data-value');
      if (eyeState.split) eyeState[eyeState.side] = val;
      else {
        eyeState.left = val;
        eyeState.right = val;
      }
      renderEyeSelection();
    });
  });

  var eyeToggle = document.getElementById('eyeToggle');
  if (eyeToggle) {
    eyeToggle.addEventListener('click', function () {
      eyeState.split = !eyeState.split;
      eyeToggle.classList.toggle('is-on', eyeState.split);
      eyeToggle.setAttribute('aria-pressed', eyeState.split ? 'true' : 'false');
      $('#eyeTabs')?.classList.toggle('is-visible', eyeState.split);
      if (!eyeState.split) {
        eyeState.right = eyeState.left;
        eyeState.side = 'left';
        $$('#eyeTabs .side-tab').forEach(function (t) {
          t.classList.toggle('is-active', t.getAttribute('data-side') === 'left');
        });
      }
      renderEyeSelection();
    });
  }

  $$('#eyeTabs .side-tab').forEach(function (tab) {
    tab.addEventListener('click', function () {
      eyeState.side = tab.getAttribute('data-side');
      $$('#eyeTabs .side-tab').forEach(function (t) {
        t.classList.toggle('is-active', t.getAttribute('data-side') === eyeState.side);
      });
      renderEyeSelection();
    });
  });

  initEyeDefault();

  var OPTION_GROUP_TITLES = {
    eye: 'Eye Color',
    mouth: 'Mouth',
    ear: 'Ear Position',
    body: 'Body Position',
    tail: 'Tail Position',
    size: 'Size',
  };

  // Size chart — data comes from the cuddleclones.options metafield
  // (cuddleclonesOptionsValue in the runtime config), same shape the legacy
  // product customizer consumes: { size: true, variant_options: [{ size_chart }] }.
  function getSizeChart() {
    var data = C.cuddleclonesOptionsValue;
    if (!data || data.size !== true) return null;
    var chart =
      data.variant_options && data.variant_options[0] && data.variant_options[0].size_chart;
    return chart && chart.data ? chart : null;
  }

  function openSizeChartPopup() {
    var popup = document.getElementById('popup');
    if (!popup) return;
    buildSizeChart();
    popup.style.display = 'block';
  }

  function closeSizeChartPopup() {
    var popup = document.getElementById('popup');
    if (popup) popup.style.display = 'none';
  }

  function activateSizeChartTab(tabBtn, country) {
    var popup = document.getElementById('popup');
    if (!popup) return;
    $$('.tabcontent', popup).forEach(function (tableEl) {
      tableEl.style.display = tableEl.getAttribute('data-country') === country ? 'table' : 'none';
    });
    $$('.tablinks', popup).forEach(function (btn) {
      btn.classList.toggle('active', btn === tabBtn);
    });
  }

  function buildSizeChart() {
    var chart = getSizeChart();
    var title = document.getElementById('sizeChartTitle');
    var tabsHost = document.getElementById('sizeChartTabs');
    var tablesHost = document.getElementById('sizeTables');
    if (!chart || !title || !tabsHost || !tablesHost) return;

    title.textContent = chart.title || 'Size Chart';
    tabsHost.innerHTML = '';
    tablesHost.innerHTML = '';

    Object.keys(chart.data).forEach(function (country, index) {
      var tab = document.createElement('button');
      tab.type = 'button';
      tab.className = 'tablinks' + (index === 0 ? ' active' : '');
      tab.textContent = country;
      tab.addEventListener('click', function () {
        activateSizeChartTab(tab, country);
      });
      tabsHost.appendChild(tab);

      var table = document.createElement('table');
      table.className = 'tabcontent';
      table.setAttribute('data-country', country);
      table.style.display = index === 0 ? 'table' : 'none';

      var headerRow = table.insertRow();
      [chart.key_name || 'Size', 'Female', 'Male'].forEach(function (heading) {
        var cell = headerRow.insertCell();
        cell.textContent = heading;
        cell.className = 'sizechart-th';
      });

      var countryData = chart.data[country];
      Object.keys(countryData).forEach(function (sizeName) {
        var row = table.insertRow();
        row.insertCell().textContent = sizeName;
        row.insertCell().textContent = countryData[sizeName].Female || '';
        row.insertCell().textContent = countryData[sizeName].Male || '';
      });
      tablesHost.appendChild(table);
    });
  }

  function bindSizeChartPopup() {
    var popup = document.getElementById('popup');
    if (!popup || popup.dataset.pccBound === 'true') return;
    popup.dataset.pccBound = 'true';
    popup.addEventListener('click', function (e) {
      if (e.target === popup) closeSizeChartPopup();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && popup.style.display === 'block') closeSizeChartPopup();
    });
    // Shared snippet close button calls closePopup() inline.
    window.closePopup = closeSizeChartPopup;
  }

  function optionGroupTitle(slug) {
    var key = String(slug || '')
      .trim()
      .toLowerCase()
      .replace(/[\s_-]+/g, '');
    if (OPTION_GROUP_TITLES[key]) return OPTION_GROUP_TITLES[key];
    if (key.indexOf('body') === 0) return OPTION_GROUP_TITLES.body;
    if (key.indexOf('tail') === 0) return OPTION_GROUP_TITLES.tail;
    if (key.indexOf('mouth') === 0) return OPTION_GROUP_TITLES.mouth;
    if (key.indexOf('ear') === 0) return OPTION_GROUP_TITLES.ear;
    return slug;
  }

  function orderPositions(petData) {
    var keys = Object.keys(petData).filter(function (k) {
      return petData[k] && petData[k].display;
    });
    var mouthIdx = keys.findIndex(function (k) {
      return /^mouth$/i.test(k);
    });
    if (mouthIdx > 0) {
      var m = keys.splice(mouthIdx, 1)[0];
      return [m].concat(keys);
    }
    return keys;
  }

  function renderPositionOptions(species) {
    var mount = document.getElementById('pcc-position-options');
    if (!mount || !C.customizer || !C.customizer[4]) return;
    mount.innerHTML = '';
    var productOptions = C.customizer[4].product_options || [];
    productOptions.forEach(function (option) {
      if (!(species in option)) return;
      var petData = option[species];
      orderPositions(petData).forEach(function (position) {
        var detail = petData[position];
        if (!detail || !detail.display || !detail.images_and_positions) return;
        var slug = position.toLowerCase();
        var isTail = slug === 'tail';
        var card = document.createElement('div');
        card.className = 'options-card';
        card.innerHTML =
          '<div class="options-header"><div class="options-header__text"><h3 class="options-title">' +
          optionGroupTitle(slug) +
          '</h3></div></div>';
        if (slug === 'size' && getSizeChart()) {
          var chartBtn = document.createElement('button');
          chartBtn.type = 'button';
          chartBtn.className = 'pcc-size-chart-link';
          chartBtn.textContent = 'View Size Chart';
          chartBtn.addEventListener('click', openSizeChartPopup);
          card.querySelector('.options-header').appendChild(chartBtn);
        }
        var grid = document.createElement('div');
        grid.className = 'option-grid' + (isTail ? ' option-grid--4' : '');
        grid.setAttribute('data-position', slug);
        detail.images_and_positions.forEach(function (item, index) {
          var itemEl = document.createElement('div');
          itemEl.className = 'option-item' + (index === 0 ? ' is-selected' : '');
          itemEl.setAttribute('data-value', item.value);
          var radio = document.createElement('input');
          radio.type = 'radio';
          radio.name = 'properties[' + slug + ']';
          radio.value = item.value;
          radio.className = 'pcc-visually-hidden';
          if (index === 0) radio.checked = true;
          var circle = document.createElement('div');
          circle.className = 'option-circle';
          var img = document.createElement('img');
          img.src = item.src;
          img.alt = item.alt || item.name || position;
          circle.appendChild(img);
          var label = document.createElement('span');
          label.className = 'option-label';
          label.textContent = (item.name || '').split('|')[0].split('\n')[0].trim() || item.alt || '';
          itemEl.appendChild(radio);
          itemEl.appendChild(circle);
          itemEl.appendChild(label);
          itemEl.addEventListener('click', function () {
            $$('.option-item', grid).forEach(function (x) {
              x.classList.remove('is-selected');
            });
            itemEl.classList.add('is-selected');
            radio.checked = true;
          });
          grid.appendChild(itemEl);
        });
        card.appendChild(grid);
        mount.appendChild(card);
      });
    });
  }

  var earState = { left: '', right: '', side: 'left', split: false };
  var earLeftPositions = [];
  var earRightPositions = [];

  function syncEarFormInputs() {
    var leftInput = document.getElementById('left-ear-value');
    var rightInput = document.getElementById('right-ear-value');
    if (leftInput) leftInput.value = earState.left;
    if (rightInput) rightInput.value = earState.split ? earState.right : earState.left;
  }

  function renderEarOptions(species) {
    var mount = document.getElementById('pcc-ear-mount');
    if (!mount || !C.customizer || !C.customizer[3]) return;
    var earData = C.customizer[3].pet_info && C.customizer[3].pet_info[2];
    if (!earData || !earData[species]) {
      mount.innerHTML = '';
      return;
    }
    var cfg = earData[species];
    var leftRaw = (cfg.ear_position && cfg.ear_position.Left) || [];
    var rightRaw = (cfg.ear_position && cfg.ear_position.Right) || [];
    earLeftPositions = leftRaw;
    earRightPositions = rightRaw.length ? rightRaw : earLeftPositions;
    if (!earLeftPositions.length) {
      mount.innerHTML = '';
      return;
    }

    earState = { left: '', right: '', side: 'left', split: false };
    mount.innerHTML = '';

    var card = document.createElement('div');
    card.className = 'options-card';
    card.id = 'pcc-ear-card';

    var header = document.createElement('div');
    header.className = 'options-header';
    header.innerHTML =
      '<div class="options-header__text"><h3 class="options-title">' +
      optionGroupTitle('ear') +
      '</h3></div>' +
      '<div class="options-toggle"><span>My pet\'s ears are different</span></div>';

    var earToggle = document.createElement('div');
    earToggle.className = 'toggle-switch';
    earToggle.id = 'earToggle';
    earToggle.setAttribute('role', 'button');
    earToggle.setAttribute('tabindex', '0');
    earToggle.setAttribute('aria-pressed', 'false');
    header.querySelector('.options-toggle').appendChild(earToggle);

    var earTabs = document.createElement('div');
    earTabs.className = 'side-tabs';
    earTabs.id = 'earTabs';
    earTabs.innerHTML =
      '<button type="button" class="side-tab is-active" data-side="left">Left Ear</button>' +
      '<button type="button" class="side-tab" data-side="right">Right Ear</button>';

    var leftGrid = document.createElement('div');
    leftGrid.className = 'option-grid';
    leftGrid.id = 'earGridLeft';

    var rightGrid = document.createElement('div');
    rightGrid.className = 'option-grid';
    rightGrid.id = 'earGridRight';
    rightGrid.hidden = true;

    function buildEarGrid(gridEl, positions, side) {
      positions.forEach(function (item) {
        var itemEl = document.createElement('div');
        itemEl.className = 'option-item';
        itemEl.setAttribute('data-value', item.value);
        itemEl.setAttribute('data-ear-side', side);
        var circle = document.createElement('div');
        circle.className = 'option-circle';
        var img = document.createElement('img');
        img.src = item.src;
        img.alt = item.alt || item.value;
        circle.appendChild(img);
        var label = document.createElement('span');
        label.className = 'option-label';
        label.textContent = item.alt || item.value;
        itemEl.appendChild(circle);
        itemEl.appendChild(label);
        itemEl.addEventListener('click', function () {
          earState[side] = item.value;
          if (!earState.split) {
            earState.left = item.value;
            earState.right = item.value;
          }
          updateEarSelectionUI();
        });
        gridEl.appendChild(itemEl);
      });
    }

    function updateEarSelectionUI() {
      [leftGrid, rightGrid].forEach(function (gridEl) {
        var side = gridEl === leftGrid ? 'left' : 'right';
        var active = earState[side];
        $$('.option-item', gridEl).forEach(function (el) {
          el.classList.toggle('is-selected', el.getAttribute('data-value') === active);
        });
      });
      syncEarFormInputs();
    }

    function updateEarPanelVisibility() {
      earTabs.classList.toggle('is-visible', earState.split);
      if (!earState.split) {
        leftGrid.hidden = false;
        rightGrid.hidden = true;
      } else {
        leftGrid.hidden = earState.side !== 'left';
        rightGrid.hidden = earState.side !== 'right';
      }
    }

    buildEarGrid(leftGrid, earLeftPositions, 'left');
    buildEarGrid(rightGrid, earRightPositions, 'right');

    if (earLeftPositions[0]) {
      earState.left = earLeftPositions[0].value;
      earState.right = (earRightPositions[0] || earLeftPositions[0]).value;
    }
    updateEarSelectionUI();
    updateEarPanelVisibility();

    card.appendChild(header);
    card.appendChild(earTabs);
    card.appendChild(leftGrid);
    card.appendChild(rightGrid);

    // Order: Eye, Mouth, Ear, Body, Tail. Insert ear card right after the
    // Mouth card inside the position flow instead of the separate ear mount.
    var posMount = document.getElementById('pcc-position-options');
    var anchorCard = null;
    if (posMount) {
      var posCards = posMount.querySelectorAll('.options-card');
      for (var ci = 0; ci < posCards.length; ci++) {
        if (posCards[ci].querySelector('.option-grid[data-position="mouth"]')) {
          anchorCard = posCards[ci];
          break;
        }
      }
      if (!anchorCard && posCards.length) anchorCard = posCards[0];
    }
    if (anchorCard) {
      posMount.insertBefore(card, anchorCard.nextSibling);
    } else {
      mount.appendChild(card);
    }

    function onEarToggle(e) {
      if (e) {
        e.preventDefault();
        e.stopPropagation();
      }
      earState.split = !earState.split;
      earToggle.classList.toggle('is-on', earState.split);
      earToggle.setAttribute('aria-pressed', earState.split ? 'true' : 'false');
      if (!earState.split) {
        earState.right = earState.left;
        earState.side = 'left';
        $$('#earTabs .side-tab', card).forEach(function (t) {
          t.classList.toggle('is-active', t.getAttribute('data-side') === 'left');
        });
      } else {
        earState.right = '';
      }
      updateEarPanelVisibility();
      updateEarSelectionUI();
    }

    earToggle.addEventListener('click', onEarToggle);
    earToggle.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        onEarToggle(e);
      }
    });

    $$('#earTabs .side-tab', card).forEach(function (tab) {
      tab.addEventListener('click', function (e) {
        e.stopPropagation();
        earState.side = tab.getAttribute('data-side');
        $$('#earTabs .side-tab', card).forEach(function (t) {
          t.classList.toggle('is-active', t.getAttribute('data-side') === earState.side);
        });
        updateEarPanelVisibility();
        updateEarSelectionUI();
      });
    });
  }

  function validateStep3() {
    var leftEye = document.getElementById('left-eye-color')?.value.trim();
    if (!leftEye) {
      alert('Please select an eye color.');
      scrollToStep(3);
      return false;
    }
    if (eyeState.split && !document.getElementById('right-eye-color')?.value.trim()) {
      alert('Please select eye colors for both eyes.');
      scrollToStep(3);
      return false;
    }
    var grids = $$('#pcc-position-options .option-grid[data-position]');
    for (var i = 0; i < grids.length; i++) {
      var checked = grids[i].querySelector('input[type="radio"]:checked');
      if (!checked) {
        alert('Please select all clone options.');
        scrollToStep(3);
        return false;
      }
    }
    var earCard = document.getElementById('pcc-ear-card');
    if (earCard) {
      syncEarFormInputs();
      if (!earState.left) {
        alert('Please select an ear position.');
        scrollToStep(3);
        return false;
      }
      if (earState.split && !earState.right) {
        alert('Please select ear positions for both ears.');
        scrollToStep(3);
        return false;
      }
    }
    var frameCard = document.getElementById('pcc-frame-card');
    if (frameCard) {
      var frameVal = document.getElementById('pcc-frame-option')?.value.trim();
      var bgVal = document.getElementById('pcc-background-option')?.value.trim();
      if (!frameVal || !bgVal) {
        alert('Please select Plush Frame and Background');
        scrollToStep(3);
        return false;
      }
    }
    return true;
  }

  function bindFrameOptions() {
    var frameCard = document.getElementById('pcc-frame-card');
    if (!frameCard) return;

    var frameInput = document.getElementById('pcc-frame-option');
    var formIdInput = document.getElementById('formId');

    $$('.pcc-frame-item', frameCard).forEach(function (item) {
      function selectFrame() {
        $$('.pcc-frame-item', frameCard).forEach(function (x) {
          x.classList.remove('is-selected');
          x.setAttribute('aria-pressed', 'false');
        });
        item.classList.add('is-selected');
        item.setAttribute('aria-pressed', 'true');
        if (frameInput) frameInput.value = item.getAttribute('data-frame-label') || '';
        var vid = item.getAttribute('data-frame-value');
        if (formIdInput && vid) formIdInput.value = vid;
        framePriceCents = parsePriceToCents(item.getAttribute('data-frame-price'));
        updateTotal();
      }
      item.addEventListener('click', selectFrame);
      item.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          selectFrame();
        }
      });
    });

    var bgCard = document.getElementById('pcc-bg-card');
    if (!bgCard) return;
    var bgInput = document.getElementById('pcc-background-option');
    $$('.pcc-bg-item', bgCard).forEach(function (item) {
      function selectBackground() {
        $$('.pcc-bg-item', bgCard).forEach(function (x) {
          x.classList.remove('is-selected');
          x.setAttribute('aria-pressed', 'false');
        });
        item.classList.add('is-selected');
        item.setAttribute('aria-pressed', 'true');
        if (bgInput) bgInput.value = item.getAttribute('data-background-label') || '';
      }
      item.addEventListener('click', selectBackground);
      item.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          selectBackground();
        }
      });
    });
  }

  function syncRushSelect(card) {
    var variantId = card.getAttribute('data-variant-id');
    var weeks = card.getAttribute('data-weeks');
    var priceCents = parseInt(card.getAttribute('data-price-cents') || '0', 10);
    var rushSelect = document.getElementById('rushSelect');
    if (!rushSelect) return;
    for (var i = 0; i < rushSelect.options.length; i++) {
      if (String(rushSelect.options[i].value) === String(variantId)) {
        rushSelect.selectedIndex = i;
        break;
      }
    }
    creationPriceCents = priceCents;
    creationWeeks = parseInt(weeks, 10) || 0;
    updateTotal();
    updateShipConfirm();
  }

  function selectCreationCard(card) {
    $$('#creationWindowList .creation-card').forEach(function (c) {
      c.classList.remove('is-on');
      var t = c.querySelector('[data-creation-toggle]');
      if (t) t.setAttribute('aria-pressed', 'false');
    });
    card.classList.add('is-on');
    var toggle = card.querySelector('[data-creation-toggle]');
    if (toggle) toggle.setAttribute('aria-pressed', 'true');
    syncRushSelect(card);
  }

  $$('#creationWindowList .creation-card').forEach(function (card, idx) {
    if (idx === 0) syncRushSelect(card);
    card.addEventListener('click', function (e) {
      if (e.target.closest('[data-creation-toggle]')) return;
      selectCreationCard(card);
    });
    var toggle = card.querySelector('[data-creation-toggle]');
    if (toggle) {
      toggle.addEventListener('click', function (e) {
        e.stopPropagation();
        selectCreationCard(card);
      });
    }
  });

  function hydrateCreationPrices() {
    var rushRoot = $('#creationWindowList');
    var handle = rushRoot ? rushRoot.getAttribute('data-rush-handle') : '';
    if (!handle) {
      $$('.creation-card').forEach(function (card) {
        var fb = card.getAttribute('data-fallback-price');
        var priceEl = card.querySelector('.pcc-creation-price');
        var cents = parsePriceToCents(fb);
        card.setAttribute('data-price-cents', String(cents));
        if (priceEl && fb) priceEl.textContent = fb;
      });
      var first = $('.creation-card.is-on');
      if (first) syncRushSelect(first);
      return;
    }
    fetch('/products/' + encodeURIComponent(handle) + '.js')
      .then(function (r) {
        return r.json();
      })
      .then(function (data) {
        var variants = data.variants || [];
        $$('.creation-card').forEach(function (card) {
          var vid = card.getAttribute('data-variant-id');
          var match = variants.find(function (v) {
            return String(v.id) === String(vid);
          });
          var cents = match ? match.price : parsePriceToCents(card.getAttribute('data-fallback-price'));
          card.setAttribute('data-price-cents', String(cents));
          var priceEl = card.querySelector('.pcc-creation-price');
          if (priceEl) {
            priceEl.textContent = cents === 0 ? 'Free' : formatMoneyCents(cents);
          }
        });
        var active = $('.creation-card.is-on');
        if (active) syncRushSelect(active);
        updateTotal();
      })
      .catch(function () {
        $$('.creation-card').forEach(function (card) {
          var fb = card.getAttribute('data-fallback-price');
          var cents = parsePriceToCents(fb);
          card.setAttribute('data-price-cents', String(cents));
          var priceEl = card.querySelector('.pcc-creation-price');
          if (priceEl && fb) priceEl.textContent = fb;
        });
        var active = $('.creation-card.is-on');
        if (active) syncRushSelect(active);
        updateTotal();
      });
  }

  function hydrateAddonPrices() {
    $$('#extrasList .extra-card[data-product-handle]').forEach(function (card) {
      var handle = (card.getAttribute('data-product-handle') || '').trim();
      var priceEl = card.querySelector('.pcc-addon-price');
      var fb = card.getAttribute('data-fallback-price') || '';
      var toggle = card.querySelector('[data-toggle]');
      if (!handle || !priceEl) {
        if (toggle) toggle.setAttribute('data-price-cents', String(parsePriceToCents(fb)));
        return;
      }
      fetch('/products/' + encodeURIComponent(handle) + '.js')
        .then(function (r) {
          return r.json();
        })
        .then(function (data) {
          var cents = data.price != null ? data.price : parsePriceToCents(fb);
          priceEl.textContent = formatMoneyCents(cents);
          if (toggle) toggle.setAttribute('data-price-cents', String(cents));
        })
        .catch(function () {
          priceEl.textContent = fb;
          if (toggle) toggle.setAttribute('data-price-cents', String(parsePriceToCents(fb)));
        });
    });
  }

  $$('#extrasList [data-info-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      var card = btn.closest('.extra-card');
      if (!card) return;
      var open = card.classList.toggle('is-info-open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  });

  $$('#extrasList .extra-card').forEach(function (card) {
    var toggle = card.querySelector('[data-toggle]');
    if (!toggle) return;
    var key = card.getAttribute('data-extra');
    var checkbox = card.querySelector('.' + key + '_checkbox');

    function setAddonState(on) {
      toggle.setAttribute('aria-pressed', on ? 'true' : 'false');
      card.classList.toggle('is-on', on);
      var price = parseInt(toggle.getAttribute('data-price-cents') || '0', 10);
      if (on) extrasTotals[key] = price;
      else delete extrasTotals[key];
      if (checkbox && checkbox.checked !== on) {
        checkbox.checked = on;
        checkbox.dispatchEvent(new Event('change', { bubbles: true }));
      }
      var hiddenFlag = document.getElementById(key);
      if (hiddenFlag) hiddenFlag.value = on ? 'Yes' : 'No';
      updateTotal();
    }

    toggle.addEventListener('click', function (e) {
      e.stopPropagation();
      var on = toggle.getAttribute('aria-pressed') === 'true';
      setAddonState(!on);
    });

    if (checkbox) {
      checkbox.addEventListener('change', function () {
        setAddonState(checkbox.checked);
      });
    }

    $$('.variant-pill', card).forEach(function (pill) {
      pill.addEventListener('click', function () {
        $$('.variant-pill', card).forEach(function (p) {
          p.classList.remove('is-active');
        });
        pill.classList.add('is-active');
        var sel = card.querySelector('.' + key + '_select');
        var vid = pill.getAttribute('data-variant-id');
        if (sel && vid) {
          for (var i = 0; i < sel.options.length; i++) {
            if (String(sel.options[i].value) === String(vid)) {
              sel.selectedIndex = i;
              break;
            }
          }
        }
      });
    });
  });

  var products = (C.customizer && C.customizer[5] && C.customizer[5].final_options && C.customizer[5].final_options.products) || [];
  function buildAddonItems(originalUniqueKey, itemQuantity) {
    var items = [];
    if (!products) return items;

    for (var i = 0; i < products.length; i++) {
      var productName = products[i].name;
      var checkbox = document.querySelector('.' + productName + '_checkbox');
      if (!checkbox || !checkbox.checked) continue;

      var selectedDropdown = document.querySelector('.' + productName + '_select');
      var selectedValue = selectedDropdown ? selectedDropdown.value : null;
      var selectedIndex = selectedDropdown ? selectedDropdown.selectedIndex : -1;

      if (selectedDropdown && (!selectedValue || selectedIndex <= 0)) {
        alert('Please select ' + productName + ' variant');
        throw new Error('variant required');
      }

      var variantId = selectedDropdown
        ? selectedValue
        : document.querySelector('.input_' + productName)?.value;

      if (!variantId) continue;

      var props = {
        _unique_key: originalUniqueKey,
        _accessories_product: true,
        _accessories_product_info: selectedPetTypeName,
      };
      if (productName === 'custom_bandana' || productName === 'bobblehead_display_stand') {
        props._accessories_product_info = getPetName();
        props.text = getPetName();
      }

      items.push({
        quantity: itemQuantity,
        id: variantId,
        properties: props,
      });
    }
    return items;
  }

  function bindAddToCart() {
    var addBtn = document.getElementById('add_to_cart');
    if (!addBtn) return;

    addBtn.addEventListener('click', function (event) {
      event.preventDefault();
      var originalUniqueKeyEl = document.getElementById('originalUniqueKey');
      if (!originalUniqueKeyEl) {
        alert('Customizer form is missing. Please refresh and try again.');
        return;
      }
      var originalUniqueKey = String(originalUniqueKeyEl.value || Date.now());
      originalUniqueKeyEl.value = originalUniqueKey;

      var origHtml = addBtn.innerHTML;
      addBtn.disabled = true;
      addBtn.innerHTML = 'Adding...';

      function resetBtn() {
        addBtn.disabled = false;
        addBtn.innerHTML = origHtml;
        addBtn.style.background = '';
      }

      function redirectToCart() {
        window.location.href = C.shopUrl + '/cart';
      }

      var itemQuantity = parseInt(document.getElementById('final_quantity')?.value || '1', 10);
      var itemsArray = [];

      try {
        itemsArray = buildAddonItems(originalUniqueKey, itemQuantity);
      } catch (e) {
        resetBtn();
        return;
      }

      var rushSelect = document.getElementById('rushSelect');
      var rushValue = rushSelect ? String(rushSelect.value || '').trim() : '';
      if (rushSelect && rushValue && rushSelect.selectedIndex > 0) {
        itemsArray.push({
          quantity: itemQuantity,
          id: rushValue,
          properties: { _rush_product: true, _unique_key: originalUniqueKey },
        });
      }

      handleImages();

      var form = document.getElementById('plush_customizer_form');
      var formData = [];
      if (typeof jQuery !== 'undefined' && form) {
        formData = jQuery(form).serializeArray();
      } else if (form) {
        new FormData(form).forEach(function (value, name) {
          formData.push({ name: name, value: value });
        });
      }

      var mainItemId = null;
      var primaryProduct = formData.reduce(function (acc, row) {
        var match = row.name.match(/^properties\[(.+?)\]$/);
        if (match) acc[match[1]] = row.value;
        else if (row.name === 'id') mainItemId = row.value;
        return acc;
      }, {});

      if (!mainItemId) {
        resetBtn();
        alert('Main product variant is missing.');
        return;
      }

      itemsArray.unshift({
        quantity: itemQuantity,
        id: mainItemId,
        properties: primaryProduct,
      });

      var combinedItems = itemsArray
        .filter(function (item) {
          return item && item.id != null && String(item.id).trim() !== '';
        })
        .map(function (item) {
          return {
            quantity: item.quantity || 1,
            id: item.id,
            properties: item.properties || {},
          };
        });

      fetch(window.location.origin + '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: combinedItems }),
      })
        .then(function (response) {
          if (response.ok) {
            redirectToCart();
            return;
          }
          if (response.status === 422) {
            var safe = combinedItems.filter(function (item) {
              return (
                String(item.id) === String(mainItemId) ||
                (item.properties && item.properties._rush_product)
              );
            });
            return fetch(window.location.origin + '/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ items: safe }),
            }).then(function (retry) {
              if (retry.ok) {
                alert('Some add-ons are unavailable and were skipped.');
                redirectToCart();
              } else {
                resetBtn();
                alert('Failed to add to cart.');
              }
            });
          }
          resetBtn();
          alert('Failed to add to cart.');
        })
        .catch(function () {
          resetBtn();
          alert('Could not add to cart. Please try again.');
        });
    });
  }

  var stickyBar = document.getElementById('stickyMobileCta');
  var step1El = document.getElementById('pcc-step1');
  if (stickyBar && step1El && 'IntersectionObserver' in window) {
    var obs = new IntersectionObserver(
      function (entries) {
        if (entries[0].isIntersecting) {
          stickyBar.classList.add('is-hidden');
          root.classList.remove('has-sticky-cta');
          obs.disconnect();
        }
      },
      { threshold: 0.1 }
    );
    obs.observe(step1El);
  }

  $$('.sticky-cta__btn, .buybox__nudge').forEach(function (el) {
    el.addEventListener('click', function (e) {
      e.preventDefault();
      scrollToStep(1);
    });
  });

  document.getElementById('petname')?.addEventListener('input', updateDynamicTitle);
  document.getElementById('pcc-step1-next')?.addEventListener('click', validateStep1);
  document.getElementById('pcc-step2-next')?.addEventListener('click', validateStep2);
  document.getElementById('pcc-step3-next')?.addEventListener('click', function () {
    if (validateStep3()) unlockStep(4);
  });
  document.getElementById('pcc-step4-next')?.addEventListener('click', function () {
    unlockStep(5);
  });
  $$('[data-pcc-back]').forEach(function (btn) {
    btn.addEventListener('click', goBack);
  });

  if (products) {
    for (var pi = 0; pi < products.length; pi++) {
      var product = products[pi];
      var productName = product.name;
      var mainCheckboxes = document.querySelectorAll('.' + productName + '_checkbox');
      if (product.detail && product.detail.dependency) {
        product.detail.dependency.forEach(function (item) {
          var itemCheckboxes = document.querySelectorAll('.' + item.product_name + '_checkbox');
          mainCheckboxes.forEach(function (mainCb) {
            mainCb.addEventListener('change', function () {
              if (mainCb.checked) {
                itemCheckboxes.forEach(function (itemCb) {
                  if (!itemCb.checked) {
                    itemCb.checked = true;
                    itemCb.dispatchEvent(new Event('change', { bubbles: true }));
                    alert(item.message);
                  }
                });
              }
            });
          });
        });
      }
      if (product.detail && product.detail.incompatibility) {
        product.detail.incompatibility.forEach(function (item) {
          var incompatibleCheckboxes = document.querySelectorAll('.' + item.product_name + '_checkbox');
          mainCheckboxes.forEach(function (mainCb) {
            mainCb.addEventListener('change', function () {
              if (mainCb.checked) {
                incompatibleCheckboxes.forEach(function (incCb) {
                  if (incCb.checked) {
                    incCb.checked = false;
                    incCb.dispatchEvent(new Event('change', { bubbles: true }));
                    alert(item.message);
                  }
                });
              }
            });
          });
        });
      }
    }

    // Lock each dependency target while any addon that depends on it stays checked.
    // Customer must uncheck the dependent addon first before the target can be removed.
    var dependentsByTarget = {};
    for (var di = 0; di < products.length; di++) {
      var depName = products[di].name;
      var depList = products[di].detail && products[di].detail.dependency;
      if (!depList) continue;
      depList.forEach(function (item) {
        (dependentsByTarget[item.product_name] =
          dependentsByTarget[item.product_name] || []).push(depName);
      });
    }
    Object.keys(dependentsByTarget).forEach(function (targetName) {
      var deps = dependentsByTarget[targetName];
      document.querySelectorAll('.' + targetName + '_checkbox').forEach(function (targetCb) {
        targetCb.addEventListener('change', function () {
          if (targetCb.checked) return;
          var stillNeeded = deps.some(function (dn) {
            var c = document.querySelector('.' + dn + '_checkbox');
            return c && c.checked;
          });
          if (stillNeeded) {
            targetCb.checked = true;
            targetCb.dispatchEvent(new Event('change', { bubbles: true }));
          }
        });
      });
    });
  }

  // Add-to-cart goes through fetch only — block native /cart/add submits and
  // implicit submission (Enter in a text field) so nothing lands in the cart
  // unintentionally (e.g. while using the size chart).
  (function guardNativeSubmit() {
    var form = document.getElementById('plush_customizer_form');
    if (!form) return;
    form.addEventListener('submit', function (e) {
      e.preventDefault();
    });
    form.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && e.target && e.target.tagName === 'INPUT') {
        e.preventDefault();
      }
    });
  })();

  bindAddToCart();
  bindFrameOptions();
  bindSizeChartPopup();
  hydrateCreationPrices();
  hydrateAddonPrices();
  updateDynamicTitle();
  updateShipConfirm();
  updateTotal();
  renderProgress();

  // Initial species render — must run last, after OPTION_GROUP_TITLES and all
  // breed/option handlers are defined; otherwise renderPositionOptions() throws
  // and aborts the rest of init (breed search/select binding never runs).
  // Prefer a stored/preselected species+breed from the customizer config so a
  // resumed/preconfigured product (e.g. horse) reflects in the UI; fall back to
  // whichever species-item is marked selected in the markup.
  var cfg0 = (C.customizer && C.customizer[0]) || {};
  var storedSpecies = cfg0.selected_pet_type == null ? '' : String(cfg0.selected_pet_type).trim();
  var storedBreed = cfg0.pet_breed == null ? '' : String(cfg0.pet_breed).trim();
  var firstSpecies = storedSpecies || getSelectedSpecies();
  if (firstSpecies) setSpecies(firstSpecies, storedBreed);
})();
